export enum ViewTypeEnum {
  List = 'List',
  Create = 'Create',
  Edit = 'Edit',
  Custom = 'Custom',
  View = 'View',
  ReportView = 'ReportView',
  MultiReportView = 'MultiReportView',
}
